module.exports = __webpack_public_path__ + "img/introducePage_show_three.bb722d1b.jpg";